import { defineMessages } from 'react-intl';

type MessageDescriptor = {
  id: string;
  defaultMessage: string;
  description: string;
};

const messages: Record<string, MessageDescriptor> = defineMessages({
  modalTitle: {
    id: 'companyDashboard.modalTitle',
    defaultMessage: 'Company Dashboards are here!',
    description: 'Title for the company dashboards modal',
  },
  introMessage: {
    id: 'companyDashboard.modal.introMessage',
    defaultMessage: 'Admins and Managers can now see:',
    description: 'Intro message for the company dashboards modal',
  },
  feature1: {
    id: 'companyDashboard.modal.feature1',
    defaultMessage: 'High-level insights into productivity across the business',
    description: 'First feature for company dashboard',
  },
  feature2: {
    id: 'companyDashboard.modal.feature2',
    defaultMessage: 'How each member is using the app',
    description: 'Second feature for company dashboard',
  },
  feature3: {
    id: 'companyDashboard.modal.feature3',
    defaultMessage: 'And more!',
    description: 'And More! feature for company dashboard',
  },
  upgradeButtonText: {
    id: 'companyDashboard.modal.upgradeButton',
    defaultMessage: 'Upgrade',
    description: 'Upgrade button text',
  },
  okButtonText: {
    id: 'companyDashboard.modal.okButton',
    defaultMessage: 'Okay',
    description: 'Okay button text',
  },
  notNowButtonText: {
    id: 'companyDashboard.modal.notNowButton',
    defaultMessage: 'Not Now',
    description: 'Not now button text',
  },
  premiumUpgradeMessage: {
    id: 'companyDashboard.modal.premiumUpgradeMessage',
    defaultMessage: 'Upgrade your plan to see how you can improve efficiency!',
    description: 'Premium message for company dashboard',
  },
  premiumAdMessage: {
    id: 'companyDashboard.modal.premiumAdMessage',
    defaultMessage:
      'Hey there 👋 Curious to see how crew members across your company are using CompanyCam? Reach out to your admin to upgrade your account and unlock Company Dashboards.',
    description: 'Premium message for company dashboard',
  },
});

export default messages;
